import * as types from '../action/actionTypes';

export function setRoute(routeState) { 
    return function (dispatch) {
        dispatch(setRouteState(routeState));
    }
}

export function setRouteState (routeState) {
    return {
        type: types.SET_MANAGE_TENANT_ROUTE,
        routeState: routeState,
    }
}

//Client Side state management
export const SaveComapnyDetailsforclient = DataForState => ({
    type: types.SET_TENANT_COMPANY_DETAILS,
    Data: DataForState
});

export const SaveAfterHoursDetailsforclient = DataForState => ({
    type: types.SET_TENANT_AFTERHOURS_DETAILS,
    Data: DataForState
});

export const SaveZonesDetailsforclient = DataForState => ({
    type: types.SET_TENANT_ZONES_DETAILS,
    Data: DataForState
});

export const SaveEmployeeDetailsforclient = DataForState => ({
    type: types.SET_TENANT_EMPLOYEE_DETAILS,
    Data: DataForState
});

export const SaveMeterDetailsforClient = DataForState => ({
    type: types.SET_METER_DETAILS,
    Data: DataForState
});

export const SaveNormalHoursDetailsforclient = DataForState => ({
    type: types.SET_TENANT_NORMALHOURS_DETAILS,
    Data: DataForState
});

export const SaveFixedChargesforclient = DataForState => ({
    type: types.SET_TENANT_FIXEDCHARGES_DETAILS,
    Data: DataForState
});

